const colorVariableMap = {
    primary: '--color-primary',
    primaryGradient: '--color-primary-gradient',
    secondary: '--color-secondary',
    secondaryGradient: '--color-secondary-gradient',
    success: '--color-success',
    danger: '--color-danger',
    warning: '--color-warning',
    info: '--color-info',
    light: '--color-light',
    dark: '--color-dark',
    white: '--color-white',
    black: '--color-black',
    gray: '--color-gray',
    silver: '--color-silver',
    gold: '--color-gold',
    pink: '--color-pink',
    purple: '--color-purple',
    indigo: '--color-indigo',
    blue: '--color-blue',
    green: '--color-green',
    yellow: '--color-yellow',
    orange: '--color-orange',
    red: '--color-red',
    background: '--color-background',
    blueLight: '--color-blue-light',
    APP_FADED_GREY: '--color-app-faded-grey',
    DARK_CHARCOAL: '--color-dark-charcoal',
    LIGHT_GRAY: '--color-light-gray',
    APP_PRIMARY_MAIN: '--color-app-primary-main',
    ERROR_BORDER: '--color-error-border',
}

const lightColors = {
    primary: '#6366f1',
    primaryGradient:
        'linear-gradient(150deg, rgba(99, 102, 241, 0.95) 0%, rgba(129, 140, 248, 0.9) 65%)',
    secondary: '#8b5cf6',
    secondaryGradient:
        'linear-gradient(160deg, rgba(139, 92, 246, 0.9) 0%, rgba(99, 102, 241, 0.75) 70%)',
    success: '#22c55e',
    danger: '#ef4444',
    warning: '#f97316',
    info: '#0ea5e9',
    light: '#f9fafb',
    dark: '#111827',
    white: '#ffffff',
    black: '#000000',
    gray: '#6b7280',
    silver: '#e0e7ff',
    gold: '#f4c152',
    pink: '#f472b6',
    purple: '#a855f7',
    indigo: '#6366f1',
    blue: '#3b82f6',
    green: '#10b981',
    yellow: '#facc15',
    orange: '#fb923c',
    red: '#ef4444',
    background: '#f9fafb',
    blueLight: '#eef2ff',
    APP_FADED_GREY: '#9ca3af',
    DARK_CHARCOAL: '#111827',
    LIGHT_GRAY: '#e5e7eb',
    APP_PRIMARY_MAIN: '#6366f1',
    ERROR_BORDER: 'rgba(239, 68, 68, 0.35)',
}

const darkColors = {
    primary: '#818cf8',
    primaryGradient:
        'linear-gradient(150deg, rgba(129, 140, 248, 0.9) 0%, rgba(99, 102, 241, 0.85) 65%)',
    secondary: '#a78bfa',
    secondaryGradient:
        'linear-gradient(160deg, rgba(167, 139, 250, 0.85) 0%, rgba(129, 140, 248, 0.75) 70%)',
    success: '#34d399',
    danger: '#f87171',
    warning: '#fb923c',
    info: '#38bdf8',
    light: '#1f2937',
    dark: '#030712',
    white: '#ffffff',
    black: '#000000',
    gray: '#9ca3af',
    silver: '#374151',
    gold: '#fbbf24',
    pink: '#f472b6',
    purple: '#c084fc',
    indigo: '#818cf8',
    blue: '#60a5fa',
    green: '#22c55e',
    yellow: '#facc15',
    orange: '#fb923c',
    red: '#f87171',
    background: '#111827',
    blueLight: '#1e1b4b',
    APP_FADED_GREY: '#6b7280',
    DARK_CHARCOAL: '#f3f4f6',
    LIGHT_GRAY: '#374151',
    APP_PRIMARY_MAIN: '#818cf8',
    ERROR_BORDER: 'rgba(248, 113, 113, 0.45)',
}

export {colorVariableMap, lightColors, darkColors}
